export enum EDocumentTemplate {
    CONTRACT = 'contract',
    PROLONGATION = 'prolongation',
}

export type TAccountContentDocumentRes = {
    statusCode: number;
    content: string;
    template: EDocumentTemplate;
};
